import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { ModalOverlayComponent } from './modal-overlay/modal-overlay.component';
import { ModalContentComponent } from './modal-content/modal-content.component';
import { ModalBodyComponent } from './modal-body/modal-body.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
import { CommonModule } from '@angular/common';
import { RoblexDirectivesModule } from '../../directives';

@NgModule({
    declarations: [
        ModalComponent,
        ModalContentComponent,
        ModalOverlayComponent,
        ModalBodyComponent,
        ModalHeaderComponent,
        ModalFooterComponent,
    ],
    imports: [
        CommonModule,
        RoblexDirectivesModule
    ],
    entryComponents: [ModalComponent],
    exports: [
        ModalBodyComponent, 
        ModalHeaderComponent, 
        ModalFooterComponent
    ],
})
export class RoblexModalModule {}
